module.exports = __webpack_public_path__ + "static/community-7e0861d3c2a4d753bf2cbc63998de555.png";